import PackageTile from './PackageTile';

export default PackageTile;
